import React, { useState, useEffect, useContext, createContext } from "react";
import axios from "axios";

// url endpoint

const AmountContext = createContext();

const AmountProvider = ({ children }) => {
  const [rowMarket, setRowMarket] = useState({
    anwar: 0,
    uthpol: 0,
    najmul: 0,
    forhad: 0,
    harun: 0,
    kayser: 0,
  });

  const [accessory, setAccessory] = useState({
    groceryMarket: 0,
    wifi: 0,
    electricity: 0,
    gas: 0,
    houseRent: 0,
    cooker: 0,
  });

  const [payable, setPayable] = useState({
    anwar: 0,
    uthpol: 0,
    najmul: 0,
    forhad: 0,
    harun: 0,
    kayser: 0,
  });

  const [totalRowMarket, setTotalRowMarket] = useState(0);
  const [totalAccessory, setTotalAccessory] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [avgAmount, setAvgAmount] = useState(0);

  const handleRowMarketChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setRowMarket({ ...rowMarket, [name]: value });
  };

  const handleAccessoryChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAccessory({ ...accessory, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const totalRowMarket =
      +rowMarket.anwar +
      +rowMarket.uthpol +
      +rowMarket.najmul +
      +rowMarket.forhad +
      +rowMarket.harun +
      +rowMarket.kayser;

    const totalAccessory =
      +accessory.groceryMarket +
      +accessory.wifi +
      +accessory.electricity +
      +accessory.gas +
      +accessory.houseRent +
      +accessory.cooker;

    setTotalRowMarket(totalRowMarket);
    setTotalAccessory(totalAccessory);

    const totalAmount = +totalRowMarket + +totalAccessory;
    setTotalAmount(totalAmount);

    const avgAmount = +totalAmount / 6;
    setAvgAmount(avgAmount);

    setPayable({
      anwar: +avgAmount - +rowMarket.anwar,
      uthpol: +avgAmount - +rowMarket.uthpol,
      najmul: +avgAmount - +rowMarket.najmul,
      forhad: +avgAmount - +rowMarket.forhad,
      harun: +avgAmount - +rowMarket.harun,
      kayser: +avgAmount - +rowMarket.kayser,
    });
  };
  return (
    <AmountContext.Provider
      value={{
        rowMarket,
        handleRowMarketChange,
        accessory,
        handleAccessoryChange,
        handleSubmit,
      }}
    >
      {children}
    </AmountContext.Provider>
  );
};

export const useAmount = () => {
  return useContext(AmountContext);
};

export { AmountContext, AmountProvider };
